import MainNav from "../components/mainNav";
import SideNavBody from "../components/sideNavBody";

const Favourites = ({title}) => {
    return ( 
        <main>
            <MainNav />
            <SideNavBody title={title}/>
        </main>
     );
}
 
export default Favourites;